import { useState } from 'react';

type DeviceInfoModal = {
  isPopupOpen: boolean;
  handleOpenPopup: (isOpen: boolean) => void;
};

const useDeviceInfoModal = (): DeviceInfoModal => {
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);

  const handleOpenPopup = (isOpen: boolean): void => {
    setIsPopupOpen(isOpen);
  };

  return {
    isPopupOpen,
    handleOpenPopup,
  };
};

export default useDeviceInfoModal;
